export default __webpack_public_path__ + "static/img-3min-top-64446df84155838c50fbb1c34b8ec846.png";